import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function twPrefix(classes: string): string {
  return classes
    .split(/\s+/)
    .filter(Boolean)
    .map((cls) => (cls.startsWith('tw:') ? cls : `tw:${cls}`))
    .join(' ');
}
